<template>
    <div class="position-relative">
        <div class="row" v-if="radioButtons === true">
            <div class="col-12 col-sm-6" v-for="result in results">
                <div class="form-check form-check-inline">
                    <input data-hj-whitelist class="form-check-input" v-model="selected" type="radio" :id="result.location_id" :value="result.location_id">
                    <label class="form-check-label" :for="result.location_id">{{result.name}}</label>
                </div>
            </div>
            <br />
        </div>
        <select v-if="radioButtons !== true" v-model="selected" class="custom-select" :id="id" :disabled="loaded === null">
            <option v-for="result in results" :value="result.location_id">{{result.name}}</option>
        </select> <em class="fa fa-sync fa-spin position-absolute loader" v-show="loaded===null"></em>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                results: [],
                selected: null,
                loaded: null,
                errors: [],
                q: '',
            }
        },
        props: {
            value: [Number, null],
            id: [String],
            radioButtons: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            results() {
                this.$store.commit('locationsStore/locations', this.results);
            },
            selected(n, o) {
                this.$emit('input', n);
            },
            value(n, o) {
                this.selected = this.value;
            }
        },
        mounted() {
            if(this.value) {
                this.selected = this.value;
            }
            if(this.$store.getters['locationsStore/locations'] !== null) {
                this.results = this.$store.getters['locationsStore/locations'];
                this.loaded = new Date();
            } else {
                this.refresh();
            }
        },
        computed: {
        },
        methods: {
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/ep/locations')
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            select(result) {
                this.$emit('input', result);
                this.hide();
            }
        }
    }
</script>

<style lang="scss">
    .loader {
        margin-top: -22px;
        margin-left: 12px;
    }
</style>